var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',_vm._b({attrs:{"prop":_vm.header.prop,"label":_vm.header.label,"width":_vm.header.width,"min-width":_vm.header.minWidth,"header-align":"center","align":"center","sortable":_vm.header.sortable,"show-overflow-tooltip":"","formatter":_vm.header.formatter}},'el-table-column',_vm.header.others,false))
}
var staticRenderFns = []

export { render, staticRenderFns }